// components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles }) => {
  // Get user + role
  const user =
    JSON.parse(localStorage.getItem("user")) ||
    JSON.parse(sessionStorage.getItem("user"));

  const role =
    localStorage.getItem("role_name") ||
    sessionStorage.getItem("role_name");

  // If no user → kick back to login
  if (!user) {
    return <Navigate to="/" />;
  }

  // If allowedRoles is passed and user doesn't match → block
  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;
